import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [MatButton, NgIf, MatProgressSpinner, NgTemplateOutlet, NgClass, MatTooltipModule],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
})
export class ButtonComponent {
    @Input() type: 'icon' | 'stroked' | 'flat' | 'text' = 'stroked';
    @Input() color: 'primary' | 'danger' = 'primary';
    @Input() icon!: string;
    @Input() iconPos: 'before' | 'after' = 'before';
    @Input() buttonText!: string;
    @Input() disabled = false;
    @Input() isLoading = false;
    @Input() highlight = false;
    @Input() tooltip = '';
    @Output() buttonClick = new EventEmitter<MouseEvent>();
}
